export class BaseRestoreVMPlan {
  public PointInTimeUTC: Date | string;
  public PointInTime: Date | string;
  public RestoreSourcePrefix: string;
  public Name: string;
}
